import ConstantHelper from "~helpers/ConstantHelper";

export const [billSettingsCurrencyCode, billSettingsCurrencyCodeOptions, billSettingsCurrencyCodeMap] =
  ConstantHelper.typify({
    USD: "$",
    TRY: "₺",
    EUR: "€",
  });

export const [invoiceTypes, invoiceTypesOptions, invoiceTypesMap] = ConstantHelper.typify({
  SATIS: window.t("constants.invoiceTypes.sales"),
  ISTISNA: window.t("constants.invoiceTypes.exception"),
});
